var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNew = function SvgNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.447 2.135L15.59 14.014l-13.11 1.91c-2.35.342-3.293 3.24-1.588 4.9l9.483 9.24L8.133 43.12c-.404 2.36 2.082 4.127 4.163 3.023l11.726-6.163 11.727 6.163c2.081 1.095 4.566-.664 4.163-3.023l-2.243-13.054 9.483-9.242c1.705-1.66.763-4.557-1.588-4.898l-13.108-1.911-5.859-11.88c-1.05-2.116-4.09-2.143-5.15 0z",
    fillRule: "evenodd"
  })));
};
export default SvgNew;